/**
 * The query parameter used to identify the My Learning tab.
 */
export const MY_LEARNING_QUERY_PARAM = 'myLearningTab';

/**
 * Represents the possible values for the `myLearningTab` query parameter in the URL.
 */
export const QUERY_PARAM_VALUES = {
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  SAVED: 'SAVED',
  CERTIFICATES: 'CERTIFICATES',
  SKILLS_DASHBOARD: 'SKILLS_DASHBOARD',
  STARTING_LATER: 'STARTING_LATER',
} as const;

export type QueryParamValue = (typeof QUERY_PARAM_VALUES)[keyof typeof QUERY_PARAM_VALUES];

export const PAGE_SIZE_DEFAULT = 8;
